// apps/frontend/src/features/experiential/api.ts
import { API_BASE } from "../../config";
import { reportPaymentRequired } from "../../lib/api-client";
import { ChairInput, ChairResponse, RescriptResponse, VisualKind, VisualResponse } from "./types";

type GetToken = () => Promise<string | null>;

async function postJson<T>(getToken: GetToken, path: string, body: unknown): Promise<T> {
  const token = await getToken();
  if (!token) throw new Error("Not authenticated");
  const resp = await fetch(`${API_BASE}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify(body),
  });
  const text = await resp.text();
  let data: any = {};
  try { data = text ? JSON.parse(text) : {}; } catch { /* non-JSON */ }
  if (!resp.ok) {
    reportPaymentRequired(resp.status, data); // experiential tools are Pro-gated
    throw new Error(data?.error || `Request failed (${resp.status})`);
  }
  return data as T;
}

export interface ChairRequest {
  patient_id: string; session_id?: string; language: "en" | "hu"; chairs: ChairInput[];
}
export interface RescriptRequest {
  patient_id: string; session_id?: string; scene_prompt: string; rescript_prompt: string;
}

export function postChair(getToken: GetToken, req: ChairRequest): Promise<ChairResponse> {
  return postJson<ChairResponse>(getToken, "/experiential/chair", req);
}
export interface SuggestedChair { mode: string; label: string; text: string; voice: string; rationale: string }
export function postChairSuggest(
  getToken: GetToken, req: { patient_id: string; session_ids: string[]; language: "en" | "hu" },
): Promise<SuggestedChair[]> {
  return postJson<{ chairs: SuggestedChair[] }>(getToken, "/experiential/chair/suggest", req).then((r) => r.chairs);
}
export function postRescript(getToken: GetToken, req: RescriptRequest): Promise<RescriptResponse> {
  return postJson<RescriptResponse>(getToken, "/experiential/rescript", req);
}

export interface VisualRequest {
  patient_id: string; session_id?: string; kind: VisualKind; prompt: string; count?: number;
}
export function postVisual(getToken: GetToken, req: VisualRequest): Promise<VisualResponse> {
  return postJson<VisualResponse>(getToken, "/experiential/visual", req);
}
